// extracted by mini-css-extract-plugin
export var headerCell = "_59-1";
export var loadingSpinnerContainer = "_59-4";
export var loadingStateCell = "_59-5";
export var rowWrapper = "_59-3";
export var standaloneTable = "_59-6";
export var table = "_59-0";
export var white = "_59-2";